export default "__VITE_ASSET__DDwsMj4q__"